export const addDepositAmtToCDList = (CDList, depositAmt, autoRollover, gameDate) => {
    const gameMonth = gameDate.split('-')[1];
    const CDIndx = CDList.findIndex(elem => elem.startDate.split('-')[1] === gameMonth);
    if (CDIndx === -1){
        const CDListObj = {startDate: gameDate,
            amount: depositAmt,
            transferAmt: 0,
            autoRollover: autoRollover
        }
        CDList.push(CDListObj);
    }else{
        CDList[CDIndx].fullAmount = (+CDList[CDIndx].fullAmount + +depositAmt).toString();
    }
}
export default addDepositAmtToCDList;